// Given an x and y, it will return the magnitude and geographical angle.
const coordinatesToAngleAndMagnitude = ({ x, y, direction }: { x: number; y: number; direction?: 'from' | 'to' }) => {
    const magnitude = Math.abs(Math.sqrt(x * x + y * y));
    const mathematicalDirection = Math.round((Math.atan2(y, x) * 180) / Math.PI);
    const angle = mathematicalDirection * -1 + 90 + 360 + ((direction === 'from' ? -180 : 0) % 360);
    return { magnitude, angle };
};

export default coordinatesToAngleAndMagnitude;
